"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinBet = exports.getNumberCombinations = exports.getStakePerCombination = exports.getSuggests = exports.getSystemTotals = exports.getExpressTotals = exports.getSingleTotals = exports.convertBetslipOddToMaxBetOddType = exports.convertNewBetsToMaxBetOddTypes = exports.convertViewMaxStake = exports.getAvailableStakes = exports.getErrorMsg = exports.getInitialBetslipBet = exports.createBetslipOdd = exports.expireBetslip = exports.outboundExpireBetslipTransform = exports.inboundExpireBetslipTransform = exports.createBetslipBet = exports.getBetslipOddId = exports.createTransformDebug = exports.outboundTransform = exports.inboundTransform = exports.getNextModeBySize = exports.getStatus = exports.composeBet = exports.getBetSystemSizes = exports.handleRehydrate = void 0;
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var redux_persist_1 = require("redux-persist");
var debug_1 = __importDefault(require("debug"));
var core_1 = __importStar(require("@gin-betting/core"));
var constants_1 = require("./constants");
var handleRehydrate_1 = require("./reducer-handlers/handleRehydrate");
Object.defineProperty(exports, "handleRehydrate", { enumerable: true, get: function () { return __importDefault(handleRehydrate_1).default; } });
var _a = core_1.default.utils, splitOddPath = _a.splitOddPath, getIdsFromBetslipOddId = _a.getIdsFromBetslipOddId, joinIdPath = _a.joinIdPath, isArgsImmutable = _a.isArgsImmutable, replaceBetslipBetIdInBetslipOddId = _a.replaceBetslipBetIdInBetslipOddId, combine = _a.combine, appServiceLocator = core_1.default.appServiceLocator;
var debugPath = 'app:betslip:utils:';
var apiClient = appServiceLocator.get('apiClient');
var prevMinBet = 0;
function getBetSystemSizes(_a) {
    var betType = _a.betType, _b = _a.selectionsCount, selectionsCount = _b === void 0 ? 1 : _b, _c = _a.systemSize, systemSize = _c === void 0 ? [] : _c;
    switch (betType) {
        case core_1.GQL.BetType.SINGLE: {
            return [1];
        }
        case core_1.GQL.BetType.EXPRESS: {
            return [selectionsCount];
        }
        case core_1.GQL.BetType.SYSTEM: {
            return systemSize.filter(function (combinationNumber) { return combinationNumber < selectionsCount; });
        }
        default: {
            return [];
        }
    }
}
exports.getBetSystemSizes = getBetSystemSizes;
function composeBet(_a) {
    var stake = _a.stake, type = _a.type, newBets = _a.newBets, systemSize = _a.systemSize, oddAcceptStrategy = _a.oddAcceptStrategy, meta = _a.meta, stakeMode = _a.stakeMode;
    var debug = debug_1.default(debugPath + "composeBet");
    debug('args', {
        stake: stake,
        type: type,
        newBets: newBets,
        systemSize: systemSize,
    });
    // FIXME: naming "odds/bets"
    var odds = newBets.map(function (newBet) {
        var id = newBet.id, oddRatio = newBet.oddRatio;
        var oddPathId = getIdsFromBetslipOddId(id).oddId;
        var _a = splitOddPath(oddPathId), matchId = _a.matchId, marketId = _a.marketId, oddId = _a.oddId;
        return {
            matchId: matchId,
            marketId: marketId,
            oddId: oddId,
            ratio: oddRatio,
        };
    });
    var variables = {
        type: type,
        stake: stake,
        odds: odds,
        systemSize: getBetSystemSizes({
            betType: type,
            selectionsCount: odds.length,
            systemSize: systemSize,
        }),
        meta: meta,
        stakeMode: stakeMode,
        oddAcceptStrategy: constants_1.ODD_ACCEPT_STRATEGIES_MAPPING[oddAcceptStrategy],
    };
    return variables;
}
exports.composeBet = composeBet;
function extractStatusFromBetslipOdd(betslipOdd) {
    return betslipOdd ? betslipOdd.singleStatus : core_1.App.BetslipStatus.INITIAL;
}
function getStatus(args) {
    var debug = debug_1.default(debugPath + "getStatus");
    debug('args', args);
    var statuses;
    if (isArgsImmutable(args)) {
        var betslipOddIds = args.betslipOddIds, betslipOdds_1 = args.betslipOdds;
        statuses = betslipOddIds.map(function (betslipOddId) {
            return extractStatusFromBetslipOdd(betslipOdds_1.get(betslipOddId));
        });
    }
    else {
        var betslipOddIds = args.betslipOddIds, betslipOdds_2 = args.betslipOdds;
        statuses = immutable_1.OrderedSet(betslipOddIds.map(function (betslipOddId) {
            return extractStatusFromBetslipOdd(betslipOdds_2[betslipOddId]);
        }));
    }
    if (statuses.has(core_1.App.BetslipStatus.PROCESSING)) {
        return core_1.App.BetslipStatus.PROCESSING;
    }
    if (statuses.has(core_1.App.BetslipStatus.ERROR)) {
        return core_1.App.BetslipStatus.ERROR;
    }
    if (statuses.has(core_1.App.BetslipStatus.SUCCESS)) {
        return core_1.App.BetslipStatus.SUCCESS;
    }
    return core_1.App.BetslipStatus.INITIAL;
}
exports.getStatus = getStatus;
function getNextModeBySize(_a) {
    var mode = _a.mode, nextBetslipOddIds = _a.nextBetslipOddIds, _b = _a.isIncreasing, isIncreasing = _b === void 0 ? false : _b;
    var debug = debug_1.default('app:betslip:utils:getNextModeBySize');
    var nextSize = nextBetslipOddIds.size;
    debug('args', {
        mode: mode,
        nextSize: nextSize,
        isIncreasing: isIncreasing,
    });
    if (nextSize < constants_1.MIN_EXPRESS_SIZE)
        return core_1.GQL.BetType.SINGLE;
    if (isIncreasing) {
        var firstBetslipOddId = nextBetslipOddIds.first();
        var lastBetslipOddId = nextBetslipOddIds.last();
        if (nextSize === constants_1.MIN_EXPRESS_SIZE &&
            firstBetslipOddId &&
            lastBetslipOddId) {
            var firstBetslipOddIds = getIdsFromBetslipOddId(firstBetslipOddId);
            var lastBetslipOddIds = getIdsFromBetslipOddId(lastBetslipOddId);
            var isConflict = lastBetslipOddIds.matchId === firstBetslipOddIds.matchId ||
                lastBetslipOddIds.marketId === firstBetslipOddIds.marketId;
            if (!isConflict) {
                return core_1.GQL.BetType.EXPRESS;
            }
        }
    }
    else if (mode === core_1.GQL.BetType.SYSTEM && nextSize === constants_1.MIN_EXPRESS_SIZE) {
        return core_1.GQL.BetType.EXPRESS;
    }
    return mode;
}
exports.getNextModeBySize = getNextModeBySize;
function inboundTransform(inboundState, key) {
    if (process.env.NODE_ENV === 'production')
        return inboundState;
    var debug = debug_1.default(debugPath + "createTransform");
    debug('serialized and stored', {
        inboundState: inboundState,
        key: key,
    });
    var betslipBets = inboundState.betslipBets, betslipOdds = inboundState.betslipOdds;
    var wasteBetslipOdds = betslipOdds.filter(function (betslipOdd) {
        var keys = Object.keys(betslipOdd);
        return keys.length !== 9;
    });
    var wasteBetslipBets = betslipBets.filter(function (betslipBet) {
        var keys = Object.keys(betslipBet);
        var wrongBetslipOddIds = betslipBet.betslipOddIds.filter(function (betslipOddId) { return !betslipOdds.has(betslipOddId); });
        if (wrongBetslipOddIds.size > 0) {
            console.warn('BetslipBet has wrongBetslipOddIds.', {
                wrongBetslipOddIds: wrongBetslipOddIds,
                betslipOdds: betslipOdds,
            });
            return true;
        }
        return keys.length !== 6;
    });
    if (wasteBetslipOdds.size > 0) {
        console.warn('FIX wasteBetslipOdds:', {
            wasteBetslipOdds: wasteBetslipOdds,
            wasteBetslipBets: wasteBetslipBets,
        });
    }
    if (wasteBetslipBets.size > 0) {
        console.warn('FIX wasteBetslipBets:', {
            wasteBetslipOdds: wasteBetslipOdds,
            wasteBetslipBets: wasteBetslipBets,
        });
    }
    return inboundState;
}
exports.inboundTransform = inboundTransform;
function outboundTransform(outboundState, key) {
    var debug = debug_1.default(debugPath + "createTransform");
    debug('rehydrated into redux', {
        outboundState: outboundState,
        key: key,
    });
    return outboundState;
}
exports.outboundTransform = outboundTransform;
exports.createTransformDebug = redux_persist_1.createTransform(inboundTransform, outboundTransform, { whitelist: ['betslip'] });
var getBetslipOddId = function (_a) {
    var oddId = _a.oddId, betslipBetId = _a.betslipBetId;
    return joinIdPath(oddId, betslipBetId);
};
exports.getBetslipOddId = getBetslipOddId;
function createBetslipBet(predefinedBetslipOdds) {
    if (predefinedBetslipOdds === void 0) { predefinedBetslipOdds = []; }
    var betslipBetId = "" + Date.now();
    var betslipOddIds = predefinedBetslipOdds.map(function (betslipOddId) {
        return replaceBetslipBetIdInBetslipOddId({
            betslipOddId: betslipOddId,
            newBetslipBetId: betslipBetId,
        });
    });
    return {
        id: betslipBetId,
        mode: core_1.GQL.BetType.SINGLE,
        stake: '',
        betslipOddIds: immutable_1.OrderedSet(betslipOddIds),
        systemSize: [],
    };
}
exports.createBetslipBet = createBetslipBet;
function inboundExpireBetslipTransform(inboundState) {
    var currentTime = Date.now();
    var hour = 3600000;
    var hourLater = currentTime + hour;
    inboundState.expireAt = hourLater;
    return inboundState;
}
exports.inboundExpireBetslipTransform = inboundExpireBetslipTransform;
function outboundExpireBetslipTransform(outboundState) {
    var defaultState = {
        betslipBets: {},
        betslipOdds: {},
    };
    var expirationDate = outboundState.expireAt;
    if (expirationDate) {
        if (expirationDate < Date.now()) {
            return defaultState;
        }
    }
    return outboundState;
}
exports.outboundExpireBetslipTransform = outboundExpireBetslipTransform;
exports.expireBetslip = redux_persist_1.createTransform(inboundExpireBetslipTransform, outboundExpireBetslipTransform, { whitelist: ['betslip'] });
function createBetslipOdd(betslipOddId) {
    return {
        id: betslipOddId,
        betId: null,
        fixedCoef: null,
        singleStatus: core_1.App.BetslipStatus.INITIAL,
        singleStake: '',
    };
}
exports.createBetslipOdd = createBetslipOdd;
function getInitialBetslipBet(args) {
    var debug = debug_1.default(debugPath + "getInitialBetslipBet");
    debug('args', args);
    if (isArgsImmutable(args)) {
        return args.betslipBets.findLast(function (betslipBet) {
            var betslipOddIds = betslipBet.betslipOddIds;
            var status = getStatus({
                betslipOddIds: betslipOddIds,
                betslipOdds: args.betslipOdds,
            });
            return status === core_1.App.BetslipStatus.INITIAL;
        });
    }
    var betslipBets = args.betslipBets, betslipOdds = args.betslipOdds;
    return lodash_1.findLast(betslipBets, function (betslipBet) {
        var betslipOddIds = betslipBet.betslipOddIds;
        var status = getStatus({
            betslipOddIds: betslipOddIds,
            betslipOdds: betslipOdds,
        });
        return status === core_1.App.BetslipStatus.INITIAL;
    });
}
exports.getInitialBetslipBet = getInitialBetslipBet;
function getErrorMsg(singleError, formatMessage, messages) {
    var debug = debug_1.default(debugPath + "getErrorMsg");
    debug('args', {
        singleError: singleError,
    });
    if (!singleError) {
        console.warn('Can not found error message or decline reason');
        return formatMessage(messages.placeBetError);
    }
    var errorMessageId = constants_1.errorCodes[singleError] ||
        lodash_1.find(constants_1.PARTS_OF_ERROR_CODES, function (_msg, partOfErrorCode) {
            return singleError.includes(partOfErrorCode);
        });
    if (errorMessageId && messages[errorMessageId]) {
        return formatMessage(messages[errorMessageId]);
    }
    if (singleError.includes('Internal Error')) {
        return formatMessage(messages.internalError);
    }
    var value = singleError.replace(/^\D+/g, '');
    var text = singleError.replace(value, '');
    var messageId = constants_1.errorCodes[text];
    if (messageId && messages[messageId]) {
        return formatMessage(messages[messageId]) + " " + value;
    }
    console.warn("Key not found in errorCodes. Error msg: " + singleError);
    return singleError;
}
exports.getErrorMsg = getErrorMsg;
function getAvailableStakes(maxStake, parts) {
    if (parts === void 0) { parts = 5; }
    var maxStakeNumber = +maxStake;
    if (lodash_1.isNaN(maxStakeNumber) || parts < 1 || maxStakeNumber <= 0)
        return [];
    if (maxStakeNumber < 1)
        return [maxStakeNumber];
    var minStake = maxStakeNumber / parts;
    return lodash_1.reduce(lodash_1.range(1, parts + 1), function (availableStakes, currentPart) {
        var nextStake = minStake * currentPart;
        if (currentPart === parts) {
            nextStake = +convertViewMaxStake(nextStake.toString());
        }
        else {
            nextStake = Math.floor(nextStake);
        }
        if (nextStake !== 0 && !availableStakes.includes(nextStake)) {
            availableStakes.push(nextStake);
        }
        return availableStakes;
    }, []);
}
exports.getAvailableStakes = getAvailableStakes;
function convertViewMaxStake(maxStake) {
    var maxStakeNumber = +maxStake;
    if (lodash_1.isNaN(maxStakeNumber)) {
        return '';
    }
    var withRound = maxStakeNumber > constants_1.ROUND_MAX_STAKE;
    var result;
    if (withRound) {
        result = Math.floor(maxStakeNumber);
    }
    else {
        result = Math.floor(maxStakeNumber * 100) / 100;
    }
    return result.toString();
}
exports.convertViewMaxStake = convertViewMaxStake;
function convertNewBetsToMaxBetOddTypes(newBets) {
    return newBets.map(function (bet) {
        var oddRatio = bet.oddRatio, id = bet.id;
        var _a = getIdsFromBetslipOddId(id), marketId = _a.marketId, matchId = _a.matchId, oddId = _a.oddId;
        return {
            marketId: marketId,
            matchId: matchId,
            oddId: oddId,
            oddRatio: oddRatio,
        };
    });
}
exports.convertNewBetsToMaxBetOddTypes = convertNewBetsToMaxBetOddTypes;
function convertBetslipOddToMaxBetOddType(betslipOddId, oddRatio) {
    var _a = getIdsFromBetslipOddId(betslipOddId), marketId = _a.marketId, matchId = _a.matchId, oddId = _a.oddId;
    return {
        marketId: marketId,
        matchId: matchId,
        oddId: oddId,
        oddRatio: oddRatio,
    };
}
exports.convertBetslipOddToMaxBetOddType = convertBetslipOddToMaxBetOddType;
function getSingleTotals(betslipOddsWithOddRatio) {
    var totals = {
        totalOdd: null,
        totalWin: 0,
        totalStake: 0,
    };
    var isOneBetslipOdd = betslipOddsWithOddRatio.length === 1;
    lodash_1.forEach(betslipOddsWithOddRatio, function (betslipOddWithOddRatio) {
        var singleStake = betslipOddWithOddRatio.singleStake, singleStatus = betslipOddWithOddRatio.singleStatus, fixedCoef = betslipOddWithOddRatio.fixedCoef, oddRatio = betslipOddWithOddRatio.oddRatio;
        var ratio = lodash_1.includes(constants_1.BETSLIP_ODD_STATUSES_TO_PLACE_BET, singleStatus)
            ? oddRatio
            : fixedCoef || oddRatio;
        if (isOneBetslipOdd) {
            totals.totalOdd = ratio;
        }
        totals.totalWin += ratio * +singleStake;
        totals.totalStake += +singleStake;
    });
    return totals;
}
exports.getSingleTotals = getSingleTotals;
function getExpressTotals(betslipOddsWithOddRatio, totalStake) {
    var totalOdd = betslipOddsWithOddRatio.reduce(function (res, bet) {
        var singleStatus = bet.singleStatus, fixedCoef = bet.fixedCoef, oddRatio = bet.oddRatio;
        var ratio = lodash_1.includes(constants_1.BETSLIP_ODD_STATUSES_TO_PLACE_BET, singleStatus)
            ? oddRatio
            : fixedCoef || oddRatio;
        return res * ratio || ratio;
    }, 0);
    return {
        totalOdd: totalOdd,
        totalStake: totalStake,
        totalWin: totalOdd * totalStake,
    };
}
exports.getExpressTotals = getExpressTotals;
function getSystemTotals(betslipOddsWithOddRatio, totalStake, systemSize) {
    var totals = {
        totalOdd: 0,
        totalWin: 0,
        totalStake: 0,
    };
    var betslipOddsCount = betslipOddsWithOddRatio.length;
    var filteredSystemSize = getBetSystemSizes({
        betType: core_1.GQL.BetType.SYSTEM,
        selectionsCount: betslipOddsCount,
        systemSize: systemSize,
    });
    var arrOfCombinedBetslipOddsWithOddRatio = filteredSystemSize.map(function (combinationNumber) {
        return combine(betslipOddsWithOddRatio, combinationNumber);
    });
    arrOfCombinedBetslipOddsWithOddRatio.forEach(function (combination) {
        combination.reduce(function (acc, combinedBetslipOddsWithOddRatio) {
            var _a = getExpressTotals(combinedBetslipOddsWithOddRatio, totalStake), totalWin = _a.totalWin, totalOdd = _a.totalOdd;
            acc.totalOdd += totalOdd || 0;
            acc.totalWin += totalWin;
            acc.totalStake += totalStake;
            return acc;
        }, totals);
    });
    return totals;
}
exports.getSystemTotals = getSystemTotals;
function getSuggests(variables) {
    return apiClient
        .makeRequest({
        method: 'getBetStakeSuggest',
        variables: variables,
    })
        .then(function (_a) {
        var suggests = _a.data.suggests;
        return suggests.map(function (_a) {
            var amount = _a.amount;
            return amount;
        });
    })
        .catch(function (error) {
        console.error(error);
        return [];
    });
}
exports.getSuggests = getSuggests;
function getStakePerCombination(systemSize, betslipOddIds, stake) {
    var numberCombinations = getNumberCombinations(systemSize, betslipOddIds);
    return +(stake / numberCombinations);
}
exports.getStakePerCombination = getStakePerCombination;
function getNumberCombinations(systemSize, betslipOddIds) {
    var filteredSystemSize = getBetSystemSizes({
        betType: core_1.GQL.BetType.SYSTEM,
        selectionsCount: betslipOddIds.count(),
        systemSize: systemSize,
    });
    return filteredSystemSize.reduce(function (acc, curr) {
        return acc + combine(betslipOddIds.toArray(), curr).length;
    }, 0);
}
exports.getNumberCombinations = getNumberCombinations;
function getMinBet() {
    return {
        prevMinBet: prevMinBet,
        request: function () {
            return appServiceLocator
                .get('apiClient')
                .makeRequest({
                method: 'getMinBet',
                variables: {},
            })
                .then(function (response) {
                prevMinBet = Number(response.data.minBet.value);
                return prevMinBet;
            })
                .catch(function (error) {
                console.error(error);
                return prevMinBet;
            });
        },
    };
}
exports.getMinBet = getMinBet;
//# sourceMappingURL=utils.js.map